<template>
  <base-material-alert
    v-if="error || loginError"
    :color="$vuetify.theme.dark ? 'softBackgroundRed' : 'softError'"
    class="mb-7"
    :class="{
      'secondary--text': !$vuetify.theme.dark,
      'white--text': $vuetify.theme.dark,
    }"
  >
    <span v-if="error" class="sign-card-error">
      {{ $t(`views.sign.${error}`) }}
    </span>
    <span v-else-if="loginError" class="sign-card-error">
      {{ $t(`views.sign.${loginError}`) }}
    </span>
  </base-material-alert>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState(['loginError']),
  },
}
</script>

<style lang="scss">
.sign-card-error {
  font-size: 14px !important;
  font-weight: 300 !important;
}
</style>
